<template>
  <div class="main">
    <v-card class="main-inner">
      <v-card-title class="main-title">Deleted Posts</v-card-title>
      <v-card-text class="main-body">
        <div class="mb-4">
          <SearchBox @onChange="onSearchBoxChange" />
        </div>
        <v-data-table
          class="main-table"
          :items-per-page="paginate.first"
          :single-select="true"
          :headers="headers"
          :loading="isLoadingProperties"
          :items="adminProperties.properties"
          @input="onSelectionChange"
          loading-text="Loading..."
          hide-default-footer
          show-select
          dense
        >
          <template v-slot:item.user_id_template="{ item }">
            <v-btn
              @click="openUserProfile(item.user.id)"
              text
              width="10"
              min-width="10"
            >
              {{ item.user.id }}
            </v-btn>
          </template>
        </v-data-table>
        <div
          class="bulk-actions d-flex justify-end pt-2"
          v-if="currentBulkItem && currentBulkItem.length"
        >
          <v-btn :loading="restoreLoading" color="primary" @click="onRestore"
            >Restore</v-btn
          >
        </div>
        <div
          class="pt-8"
          v-if="adminProperties && adminProperties.properties.length > 1"
        >
          <v-pagination
            :length="adminProperties.lastPage"
            :total-visible="7"
            :value="paginate.page"
            class="mt-4 pagination"
            color="#04a777"
            circle
            @input="onPageChange"
          ></v-pagination>
          <div class="pagination-info d-flex justify-center font-weight-bold">
            {{ paginate.page * 10 - 9 }}-{{
              paginate.page * paginate.first > adminProperties.total
                ? adminProperties.total
                : paginate.page * paginate.first
            }}
            Of {{ adminProperties.total }}
            Properties
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import gql from "graphql-tag";
import SearchBox from "../components/SearchBox.vue";

export default {
  name: "DeletedProperties",
  components: {
    SearchBox,
  },
  data() {
    return {
      isLoadingProperties: false,
      paginate: {
        first: 20,
        page: 1,
      },
      headers: [
        { text: "User ID", align: "start", value: "user_id_template" },
        { text: "Post ID", align: "left", value: "id" },
        { text: "Deleted Date", align: "left", value: "deleted_at" },
      ],

      currentBulkItem: null,

      restoreLoading: false,

      filterIds: [],
    };
  },
  computed: {
    saveFiltersPayload() {
      const obj = JSON.parse(
        JSON.stringify(this.$store.getters["home/getSaveFilterPayload"])
      );
      delete obj.currency_id;
      return obj;
    },
  },
  methods: {
    getProperties() {
      this.isLoadingProperties = true;
      this.$apollo.queries.adminProperties.skip = false;
      this.$apollo.queries.adminProperties.refetch().then(() => {
        this.isLoadingProperties = false;
        this.$nextTick(() => {
          this.$apollo.queries.adminProperties.skip = true;
        });
      });
    },
    onSelectionChange(v) {
      this.currentBulkItem = v;
    },
    openUserProfile(id) {
      this.$router.push(`/admin/user/${id}`);
    },
    onPageChange(n) {
      this.paginate.page = n;
      this.getProperties();
    },
    onSearchBoxChange(v) {
      this.filterIds = v.map((el) => +el);
    },
    onRestore() {
      this.restoreLoading = true;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation adminUpdateProperty($input: AdminUpdatePropertyInput) {
              adminUpdateProperty(input: $input) {
                id
              }
            }
          `,
          variables: {
            input: {
              id: +this.currentBulkItem[0].id,
              is_delete: false,
            },
          },
        })
        .then(() => {
          this.paginate.page = 1;
          this.getProperties();
          this.restoreLoading = false;
          this.currentBulkItem = null;
          this.$swal.fire({
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
  },
  watch: {
    filterIds() {
      this.paginate.page = 1;
      this.getProperties();
    },
    saveFiltersPayload: {
      deep: true,
      handler() {
        this.paginate.page = 1;
        this.getProperties();
      },
    },
  },
  apollo: {
    adminProperties: {
      query: gql`
        query adminProperties($input: AdminPropertiesFiltersInput) {
          adminProperties(input: $input) {
            properties {
              id
              user {
                id
              }
              deleted_at
            }
            total
            lastPage
          }
        }
      `,
      fetchpolicy: "network-only",
      skip() {
        return true;
      },
      variables() {
        return {
          input: {
            ids: this.filterIds,
            is_delete: true,
            paginate: this.paginate,
            latest: true,
            ...this.saveFiltersPayload,
          },
        };
      },
    },
  },
  created() {
    this.getProperties();
  },
};
</script>

<style scoped>
.main {
  width: 100%;
  height: 100vh;
  padding: 132px 10px 50px 110px;
  background: #fafafa;
  overflow-y: auto;
}
.main-title {
  border-bottom: 1px solid silver;
  margin-bottom: 40px;
}
.main-table >>> .v-data-table-header th {
  color: #04a777 !important;
  font-size: 17px;
}
.main-table >>> .v-data-table-header th:not(th:last-child) {
  width: 150px;
}
.pagination {
  display: flex;
  justify-content: center !important;
}
.pagination >>> .v-pagination {
  width: max-content;
}
.pagination >>> .v-pagination__navigation--disabled {
  display: none !important;
}
.pagination >>> .v-pagination__item--active {
  border: 1px solid #04a777;
}
.pagination >>> .v-pagination__item,
.pagination >>> .v-pagination__navigation {
  box-shadow: none !important;
  background: white !important;
  border: 1px solid #c4c4c4;
  font-weight: 600;
  color: black !important;
}
.pagination >>> .v-pagination__more {
  width: 34px;
  height: 34px;
  background: white;
  border: 1px solid #c4c4c4;
}
.pagination-info {
  font-size: 12px;
  margin-bottom: 20px;
}
</style>
